export default __webpack_public_path__ + "static/media/ngong catholic.67a2afc7.PNG";